import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/Login', meta: { title: '' } },
  { path: '/Login', component: () => import('../views/Login.vue'), meta: { title: '登录' } },
  {
    path: '/Home',
    component: () => import('../views/Home.vue'),
    meta: { title: 'Aptus' },
    children: [
      { path: '/', redirect: '/HomePage', meta: { title: '' } },
      // 首页
      { path: '/HomePage', component: () => import('../views/HomePage.vue'), meta: { title: '管理平台' } },
      // 终端用户管理
      { path: '/TerminalUserManagement', component: () => import('../views/TerminalUserManagement.vue'), meta: { title: '管理平台' } },
      // 设备报警
      { path: '/DeviceAlarm', component: () => import('../views/DeviceAlarm.vue'), meta: { title: '管理平台' } },
      // 设备管理
      { path: '/DeviceManagement', component: () => import('../views/DeviceManagement.vue'), meta: { title: '管理平台' } },
      // 动作库管理
      { path: '/ActionDatabaseManagement', component: () => import('../views/ActionDatabaseManagement.vue'), meta: { title: '管理平台' } },
      // 课程管理
      { path: '/CourseDatabaseManagement', component: () => import('../views/CourseDatabaseManagement.vue'), meta: { title: '管理平台' } },
      // 训练计划管理
      { path: '/TrainPlanDatabaseManagement', component: () => import('../views/TrainPlanDatabaseManagement.vue'), meta: { title: '管理平台' } },
      // 消息中心管理
      { path: '/NoticeManagement', component: () => import('../views/NoticeManagement.vue'), meta: { title: '管理平台' } },
      // 帮助中心管理
      { path: '/HelpCenterManagement', component: () => import('../views/HelpCenterManagement.vue'), meta: { title: '管理平台' } },
      // 意见反馈管理
      { path: '/FeedbackManagement', component: () => import('../views/FeedbackManagement.vue'), meta: { title: '管理平台' } },
      // 奖品管理
      { path: '/RewardManagement', component: () => import('../views/RewardManagement.vue'), meta: { title: '管理平台' } },
      // 管理中心
      { path: '/DictionaryManagement', component: () => import('../views/ManagementCenter/DictionaryManagement.vue'), meta: { title: '管理平台' } },
      { path: '/I18nBatchManagement', component: () => import('../views/ManagementCenter/I18nBatchManagement.vue'), meta: { title: '国际化批量管理' } },
      { path: '/UnitManagement', component: () => import('../views/ManagementCenter/UnitManagement.vue'), meta: { title: '管理平台' } },
      { path: '/ProjectManagement', component: () => import('../views/ManagementCenter/ProjectManagement.vue'), meta: { title: '管理平台' } },
      { path: '/RoleManagement', component: () => import('../views/ManagementCenter/RoleManagement.vue'), meta: { title: '管理平台' } },
      { path: '/UserManagement', component: () => import('../views/ManagementCenter/UserManagement.vue'), meta: { title: '管理平台' } },
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
